export default __webpack_public_path__ + "media/flags/lk-33849c85.svg";